module.exports = __webpack_public_path__ + "static/media/image_45.88181795.png";